export default __webpack_public_path__ + "static/media/sales_illustration.1af51fc1.svg";